// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"autocomplete_wrapper__2koCK","content":"autocomplete_content__XKlIo","list":"autocomplete_list__2pHhy"};